import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  chargesToGenerate: {}
};

export const chargesSlice = createSlice({
  name: 'charges',
  initialState,
  reducers: {
    setChargesToGenerate: (state, action) => {
      state.chargesToGenerate = action.payload;
    }
  }
});

export const { setChargesToGenerate } = chargesSlice.actions;
export default chargesSlice.reducer;
